import { CSSProperties } from 'react';
import { ConversionEvent } from 'analytics/events';
import { Spin } from 'antd';
import { SubmitButton } from 'components/forms/StartApplicationForm/components';
import { analytics } from 'analytics/analytics';
import useTranslation from 'hooks/use-translation';

type Props = {
  attributes?: Record<string, string>;
  endpoint: string;
  buttonHeight?: CSSProperties['height'];
};

export function StartApplicationForm(props: Props): JSX.Element {
  const { endpoint, buttonHeight } = props;
  const translation = useTranslation();

  if (!translation) {
    return <Spin />;
  }

  return (
    // <form method='POST' action={endpoint}>
    <SubmitButton
      type='primary'
      htmlType='submit'
      className='navbar-application-button'
      onClick={() => {
        const event = new ConversionEvent('start-application-button');
        analytics(event);
        window.open(endpoint, '_blank');
      }}
      height={buttonHeight}
    >
      {translation.common.buttons.apply}
    </SubmitButton>
    // </form>
  );
}
